// Block legacy WooCommerce Cart endpoint requests (remnants from previous WordPress migration)
(function() {
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url);
    if (url && url.includes('wp-json/wc/store/v1/cart')) {
      return Promise.resolve(new Response(JSON.stringify({ status: 'blocked' }), {
        status: 200,
        headers: { 'Content-Type': 'application/json' }
      }));
    }
    return originalFetch.apply(this, args);
  };

  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url, ...args) {
    if (typeof url === 'string' && url.includes('wp-json/wc/store/v1/cart')) {
      url = '/cart.js'; 
    }
    return originalOpen.call(this, method, url, ...args);
  };
})();

(function() {
  // Use event capturing and stop propagation to prevent theme/third-party scripts (like Razorpay Magic Checkout) from hijacking
  document.body.addEventListener('click', function(e) {
    const trigger = e.target.closest('.m-button--cod-trigger');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      // Extract applied discount code if present
      let appliedDiscount = localStorage.getItem('minimog-discount-code') || '';
      
      if (!appliedDiscount) {
        const discountInputs = document.querySelectorAll('input[name="discount"]');
        for (const input of discountInputs) {
          const val = input.value.trim() || input.getAttribute('data-server-applied') || '';
          if (val) {
            appliedDiscount = val;
            break;
          }
        }
      }

      // Clean up common mistakes where full hint string is captured
      if (appliedDiscount.toLowerCase().includes('get 5% discount')) {
        appliedDiscount = 'Bruin5';
      } else if (appliedDiscount && appliedDiscount.includes(' ') && appliedDiscount.includes('Bruin5')) {
        appliedDiscount = 'Bruin5';
      }

      const cleanDiscount = appliedDiscount ? appliedDiscount.trim() : '';
      
      if (cleanDiscount) {
        // Send them via the discount application URL, which saves the cookie and redirects to standard checkout
        window.location.href = '/discount/' + encodeURIComponent(cleanDiscount) + '?redirect=/checkout';
      } else {
        // Go directly to native checkout
        window.location.href = '/checkout';
      }
    }
  }, true);
})();
